import styled from 'styled-components'

export const MarkTrigger = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: rgba(0, 0, 0, 0.25);
  border-top-left-radius: 0.75em;
  color: #ffffff;
  font-size: 14px;

  &.marked {
    background: #367f98;
  }
`
